import Course33MediaSection from './section';

/** Admin section for the ordered Day-0 orientation videos (slot = dayZeroVideo). */
const Course33Day0Videos = () => <Course33MediaSection mode="day0video" />;

export default Course33Day0Videos;
